import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

type FeatureFlagKey = 'activityHistorySection' | 'sessionAccess';

export type Flags = Partial<Record<FeatureFlagKey, any>>;

interface FeatureFlagsState {
  flags: Flags;
  isInitialized: boolean;
  setFlags: (flags: Flags) => void;
  setIsInitialized: (initialized: boolean) => void;
  isFeatureEnabled: (flagKey: FeatureFlagKey) => boolean;
  getFlagValue: <T>(flagKey: FeatureFlagKey, defaultValue: T) => T;
  hasFlag: (flagKey: FeatureFlagKey) => boolean;
}

export const useFeatureFlagsStore = create<FeatureFlagsState>()(
  subscribeWithSelector((set, get) => ({
    flags: {},
    isInitialized: false,

    setFlags: (flags: Flags) => {
      set({ flags });
    },

    setIsInitialized: (initialized: boolean) => {
      set({ isInitialized: initialized });
    },

    isFeatureEnabled: (flagKey: FeatureFlagKey) => {
      const { flags } = get();
      return flags[flagKey] === true;
    },

    getFlagValue: <T>(flagKey: FeatureFlagKey, defaultValue: T): T => {
      const { flags } = get();
      return (flags[flagKey] as T) ?? defaultValue;
    },

    hasFlag: (flagKey: FeatureFlagKey) => {
      const { flags } = get();
      return flagKey in flags;
    },
  })),
);
